import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4L0 6L6 12L16 2L14 0L6 8L2 4Z\" fill=\"#404041\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol